import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Select,
  Card,
  Row,
  Col,
  Drawer,
  Space,
  Typography,
  Flex,
  Radio,
  InputNumber,
  Divider,
} from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AddressType from "features/Enums/AddressType";
import {
  DoubleRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  EditFilled,
  EditOutlined,
} from "@ant-design/icons";
import {
  getAddressCountriesAPI,
  getAddressProvincesAPI,
  getClientAPI,
  getEmployeeAPI,
  getEmployeesAPI,
  GetLookupListApi,
  getSourceOfLeadsAPI,
  getStatusAPI,
} from "CommonComponents/Lookup/LookupAPI";
import { GetLeadByIdApi, UpdateLeadApi, AddLeadApi } from "../LeadsAPI";
import CountryCode from "CommonComponents/CountryCode";
import { FormattedMessage, useIntl } from "react-intl";
import AddClient from "features/Clients/Clients/AddClient";
import Clients from "features/Clients/Clients";
import { GetClientByIdApi } from "features/Clients/ClientsApi";
import { resetLeadById } from "../LeadsSlice";
import LookupTypeEnum from "features/Enums/LookupTypeEnum";
import { setClients } from "CommonComponents/Lookup/LookupSlice";
import ClientInfo from "features/Clients/Clients/ClientInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFax,
  faBuildingShield,
  faGlobe,
  faPhone,
  faPhoneAlt,
  faPhoneFlip,
  faPhoneSquare,
  faEnvelope,
  faHashtag,
  faLocation,
  faMapMarked,
  faLocationArrow,
  faLocationDot,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import QuoteAddress from "features/Clients/Quotes/QuoteAddress";
import RoleEnum from "features/Enums/RoleEnum";
function AddLead(props) {
  const [form] = Form.useForm();
  const { id: routeId } = useParams();
  // const id = props?.selectedLead?.id || routeId;
  const location = useLocation();
  const initialLead = location.state?.lead?.id;
  const intl = useIntl();
  const { Text } = Typography;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [leadType, setLeadType] = useState(true);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const companyId = localStorage.getItem("CompanyId");
  const leadDetails = useSelector((state) => state.leads.leadRecordById);
  const clients = useSelector((state) => state.lookup.clientList);
  const sourceOfLeads = useSelector((state) => state.lookup.sourceOfLead);
  const companyNames = useSelector((state) => state.lookup.companyNames);
  const employeeList = useSelector((state) => state.lookup.employeesList);
  const clientById = useSelector((state) => state.clients.clientListById);
  const statusList = useSelector((state) => state.lookup.statusList);
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const companyServices = useSelector(
    (state) => state.lookup.lookupData[LookupTypeEnum.CompanyService.id]
  );
  const [selectedSourceOfLeadId, setSelectedSourceOfLeadId] = useState(null);
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const [open2, setOpen2] = useState(false);
  const [newClientId, setNewClientId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [residentialClientId, setResidentialClientId] = useState(null);
  const [commercialClientId, setCommercialClientId] = useState(null);
  const [editClientId, setEditClientId] = useState(null);
  const [editClientModalOpen, setEditClientModalOpen] = useState(false);
  const [addressType, setAddressType] = useState("");
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [billingAddress, setBillingAddress] = useState(null);
  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [selectedBillingId, setSelectedBillingId] = useState(null);
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const id = props?.selectedLead?.id || location.state?.lead?.id || routeId;
  const mainContact = {
    name: clientById?.name || "-",
    phone: clientById?.phone || "-",
    countryCode: clientById?.countryCode || "",
    email: clientById?.email || "-",
  };
  const altContact = {
    name: clientById?.alternateName || "-",
    phone: clientById?.alternatePhone || "-",
    countryCode: clientById?.alternateCountryCode || "",
    email: clientById?.alternateEmail || "-",
  };
  const showDrawer2 = () => {
    setEditClientModalOpen(true);
    setNewClientId(null);
    setEditClientId(null);
    setOpen2(true);
  };
  const onClose2 = () => {
    setOpen2(false);
  };
  const input = {
    pageNo: props?.pagination?.pageNo ? props?.pagination?.pageNo : null,
    pageSize: props?.pagination?.pageSize ? props?.pagination?.pageSize : null,
    searchQuery: props?.pagination?.searchQuery
      ? props?.pagination?.searchQuery
      : "",
    companyFilter: props?.pagination?.companyFilter
      ? props?.pagination?.companyFilter
      : null,
    isSearch: props?.pagination?.isSearch ? props?.pagination?.isSearch : null,
    startDate: props?.pagination?.startDate
      ? props?.pagination?.startDate
      : null,
    endDate: props?.pagination?.endDate ? props?.pagination?.endDate : null,
  };
  useEffect(() => {
    if (billingAddress) {
      setSelectedBillingId(billingAddress?.id);
      //setBillingAddress(billingAddress);
    }
  }, [billingAddress]);
  useEffect(() => {
    if (deliveryAddress) {
      setSelectedShippingId(deliveryAddress?.id);
      //setShippingAddress(shippingAddress);
    }
  }, [deliveryAddress]);
  useEffect(() => {
    if (newClientId) {
      form.setFieldsValue({ clientId: newClientId });
      setSelectedClientId(newClientId);
      dispatch(GetClientByIdApi(newClientId));
      onClose2();
      dispatch(getClientAPI());
    }
  }, [newClientId]);
  useEffect(() => {
    if (initialLead) {
      dispatch(GetLeadByIdApi(initialLead));
    }
  }, [initialLead]);
  useEffect(() => {
    dispatch(getClientAPI());
    dispatch(getStatusAPI());
    dispatch(GetLookupListApi(LookupTypeEnum?.CompanyService?.id, input));
    dispatch(getEmployeesAPI());
    dispatch(getSourceOfLeadsAPI());
    dispatch(getAddressCountriesAPI());
    dispatch(getAddressProvincesAPI());
  }, [dispatch]);
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    if (clientById && selectedClientId) {
      const billingAddress = clientById.address?.find((addr) => addr.isBilling);
      form.setFieldsValue({
        countryCode:
          clientById.countryCode || form.getFieldValue("countryCode"),
        mobileNumber: clientById.phone || form.getFieldValue("mobileNumber"),
        email: clientById.email || form.getFieldValue("email"),
        address1: billingAddress?.address1 || form.getFieldValue("address1"),
        address2: billingAddress?.address2 || form.getFieldValue("address2"),
        city: billingAddress?.city || form.getFieldValue("city"),
        provinceId:
          billingAddress?.provinceId || form.getFieldValue("provinceId"),
        zip: billingAddress?.zip || form.getFieldValue("zip"),
        countryId: billingAddress?.countryId || form.getFieldValue("countryId"),
      });
    }
  }, [clientById, selectedClientId]);
  const handleSubmit = async (values) => {
    const leadData = {
      id: leadDetails?.id || 0,
      assignedCompanyId: companyId,
      sourceOfLeadId: values.sourceOfLeadId,
      leadType: values.leadType,
      clientId: values.clientId,
      countryCode: clientById?.countryCode,
      mobileNumber: clientById?.phone,
      //companyName: values.companyName,
      // dateTime: values.dateTime
      //   ? dayjs(values.dateTime).format("YYYY-MM-DD")
      //   : null,
      requirement: values.requirement,
      // statusId: values.statusId,
      email: clientById?.email,
      addressLine1: values.address1,
      addressLine2: values.address2,
      city: values.city,
      provinceId: clientById?.provinceId,
      zip: values.zip,
      countryId: clientById?.countryId,
      responsibleId: values.responsibleId,
      commisionPercentage: values.commisionPercentage,
      commisionAmount: values.commisionAmount,
      referredBy: values.referredBy,
      companyServiceId: values.companyServiceId,
      billingAddressId: selectedBillingId,
      deliveryAddressId: selectedShippingId,
    };

    try {
      if (leadDetails?.id) {
        dispatch(UpdateLeadApi(leadData, currentYear, props.pagination)).then(
          (res) => {
            navigate(`/${companyId}/${res}/lead_view`);
          }
        );
      } else {
        dispatch(
          AddLeadApi(
            leadData,
            { ...input, pageNo: props?.pagination?.pageNo, isSearch: true },
            currentYear
          )
        ).then((res) => {
          navigate(`/${companyId}/${res}/lead_view`);
        });
        form.resetFields();
        dispatch(resetLeadById());
      }
      //navigate("/leads");
      if (props?.onClose) {
        props.onClose();
      }
      setSearchValue("");
      dispatch(setClients([]));
      if (props.leadId) {
        dispatch(GetLeadByIdApi(props.leadId));
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    }
  };
  const handleCancel = () => {
    Modal.confirm({
      title: intl.formatMessage({ id: "Common.AreYouSureToCancel" }),
      content: intl.formatMessage({
        id: "Common.PopConfirm",
      }),
      okText: intl.formatMessage({ id: "Common.Yes" }),
      cancelText: intl.formatMessage({ id: "Common.No" }),
      onOk: () => {
        //props.onClose();
        form.resetFields();
        setSelectedSourceOfLeadId(null);
        setLeadType(true);
        form.setFieldsValue({ leadType: true });
        setSearchValue("");
        dispatch(setClients([]));
        setResidentialClientId(null);
        setCommercialClientId(null);
        navigate(`/${companyId}/leads`);
      },
    });
  };
  const openAddressModal = (type) => {
    setAddressType(type);
    setIsAddressModalOpen(true);
  };

  const renderAddress = (addr) => {
    if (!addr) return "-";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage === "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage === "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;

    const parts = [
      addr.address1,
      addr.address2,
      addr.city,
      provinceName,
      countryName,
      addr.zip,
    ].filter(Boolean);

    return parts.join(", ");
  };
  // const defaultStatusId = 5;
  useEffect(() => {
    if (!id) {
      dispatch(resetLeadById());
      form.resetFields();
      setSelectedClientId(null);
      setResidentialClientId(null);
      setCommercialClientId(null);
      setLeadType(true);
      setSearchValue("");
      setSelectedBillingId(null);
      setSelectedShippingId(null);
      setBillingAddress(null);
      setDeliveryAddress(null);
      dispatch(setClients([]));
      form.setFieldsValue({
        leadType: true,
      });
    } else {
      dispatch(GetLeadByIdApi(id));
    }
  }, [id]);
  useEffect(() => {
    if (id && leadDetails) {
      const transformedLeadDetails = {
        clientId: leadDetails.clientId,
        countryCode: leadDetails.countryCode,
        mobileNumber: leadDetails.mobileNumber,
        email: leadDetails.email,
        address1: leadDetails.addressLine1,
        address2: leadDetails.addressLine2,
        city: leadDetails.city,
        provinceId: leadDetails.provinceId,
        zip: leadDetails.zip,
        countryId: leadDetails.countryId,
        requirement: leadDetails.requirement,
        leadType: leadDetails.leadType,
        assignedCompanyId: leadDetails.assignedCompanyId,
        sourceOfLeadId: leadDetails.sourceOfLeadId,
        responsibleId: leadDetails.responsibleId,
        commisionPercentage: leadDetails.commisionPercentage,
        commisionAmount: leadDetails.commisionAmount,
        referredBy: leadDetails.referredBy,
        companyServiceId: leadDetails.companyServiceId,
      };

      form.setFieldsValue(transformedLeadDetails);
      setLeadType(leadDetails.leadType);
      if (leadDetails.clientId) {
        setSelectedClientId(leadDetails.clientId);
        if (leadDetails.leadType) {
          setResidentialClientId(leadDetails.clientId);
        } else {
          setCommercialClientId(leadDetails.clientId);
        }
      }
      setSelectedBillingId(leadDetails.billingAddressId || null);
      setSelectedShippingId(leadDetails.deliveryAddressId || null);
    }
  }, [leadDetails, form, id]);
  const handleChange = (value) => {
    if (leadType) {
      setResidentialClientId(value);
    } else {
      setCommercialClientId(value);
    }
    setSelectedClientId(value);

    if (value) {
      dispatch(GetClientByIdApi(value));
      setTimeout(() => {
        form.setFieldsValue({
          countryCode: clientById?.countryCode,
          mobileNumber: clientById?.phone,
          email: clientById?.email,
        });
      }, 100);
    } else {
      form.setFieldsValue({
        mobileNumber: undefined,
        email: undefined,
        address1: undefined,
        address2: undefined,
        city: undefined,
        provinceId: undefined,
        zip: undefined,
        countryId: undefined,
      });
    }
  };
  useEffect(() => {
    dispatch(getClientAPI());

    if (!id) {
      const idToSet = leadType ? residentialClientId : commercialClientId;
      setSelectedClientId(idToSet);
      form.setFieldsValue({ clientId: idToSet });

      if (idToSet) {
        dispatch(GetClientByIdApi(idToSet));
      }
    }
  }, [leadType]);
  useEffect(() => {
    if (!id && props.open) {
      form.resetFields();
      setSelectedClientId(null);
      setResidentialClientId(null);
      setCommercialClientId(null);
      setLeadType(true);
      setSearchValue("");
      dispatch(resetLeadById());
      dispatch(setClients([]));
    }
  }, [id, props.open]);
  useEffect(() => {
    if (clientById && clientById?.address) {
      setDeliveryAddress(
        clientById?.address.find(
          (a) => a.isBilling === false && a.addressType === 1
        ) || null
      );
      setBillingAddress(
        clientById?.address.find(
          (a) => a.isBilling === true && a.addressType === 2
        ) || null
      );
    } else {
      setDeliveryAddress(null);
      setBillingAddress(null);
    }
  }, [clientById]);
  useEffect(() => {
    if (id && leadDetails?.clientId) {
      dispatch(GetClientByIdApi(leadDetails.clientId));
    }
  }, [id, leadDetails?.clientId, dispatch]);
  return (
    <>
      <div
        className="medispamain"
        style={{ position: "relative", paddingBottom: 20 }}
      >
        <div className="main-area">
          <div className="title-part detailsposition">
            <Row justify="space-between">
              <Col>
                <h4>
                  {id ? (
                    <FormattedMessage id="Lead.EditLead" />
                  ) : (
                    <FormattedMessage id="Lead.Submit" />
                  )}
                </h4>
                <p className="mt-5px">
                  Create new leads along with client details.
                </p>
              </Col>
            </Row>
          </div>
          <Divider />
          <Form
            form={form}
            name="addLeadForm"
            layout="vertical"
            onFinish={handleSubmit}
            autoComplete="off"
            size="large"
            initialValues={{
              // dateTime: dayjs(),
              //countryCode: "Cell",
              // statusId: defaultStatusId,
              leadType: leadType,
            }}
          >
            <Row gutter={[16, 16]}>
              <Col sm={24} md={12} lg={14}>
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      label={<FormattedMessage id="Lead.LeadType" />}
                      name="leadType"
                      rules={[{ required: true }]}
                    >
                      <Radio.Group
                        onChange={(e) => {
                          const value = e.target.value;
                          setLeadType(value);
                          form.setFieldValue("leadType", value);
                          const clientId = value
                            ? residentialClientId
                            : commercialClientId;
                          setSelectedClientId(clientId);
                          form.setFieldValue("clientId", clientId);
                          if (!clientId) {
                            form.setFieldsValue({
                              mobileNumber: undefined,
                              email: undefined,
                              address1: undefined,
                              address2: undefined,
                              city: undefined,
                              provinceId: undefined,
                              zip: undefined,
                              countryId: undefined,
                            });
                          } else {
                            dispatch(GetClientByIdApi(clientId));
                          }
                          setSearchValue("");
                          dispatch(setClients([]));
                        }}
                        value={leadType}
                        options={[
                          {
                            value: true,
                            label: (
                              <Flex
                                gap="small"
                                justify="center"
                                align="center"
                                vertical
                              >
                                {<FormattedMessage id="Lead.Residential" />}
                              </Flex>
                            ),
                          },
                          {
                            value: false,
                            label: (
                              <Flex
                                gap="small"
                                justify="center"
                                align="center"
                                vertical
                              >
                                {<FormattedMessage id="Lead.Commercial" />}
                              </Flex>
                            ),
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  {leadType === true && (
                    <Col xs={24} sm={24} lg={12}>
                      <Form.Item
                        label={<FormattedMessage id="Lead.LeadName" />}
                        name="clientId"
                        rules={[
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: "Lead.Error.CustomerName",
                            }),
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          allowClear
                          optionLabelProp="label"
                          popupClassName="custom-company-select"
                          placeholder={intl.formatMessage({
                            id: "Lead.PlaceHolder.SelectContactPerson",
                          })}
                          style={{ width: "100%" }}
                          onChange={handleChange}
                          onSearch={(value) => {
                            setSearchValue(value);
                            if (value) {
                              dispatch(getClientAPI(value));
                            } else {
                              dispatch(getClientAPI());
                            }
                          }}
                          filterOption={false}
                          dropdownRender={(menu) => (
                            <>
                              {menu}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  type="link"
                                  icon={<PlusOutlined />}
                                  style={{
                                    padding: 0,
                                    color: "#1677ff",
                                    fontWeight: 600,
                                    marginLeft: 8,
                                  }}
                                  onClick={showDrawer2}
                                >
                                  <FormattedMessage
                                    id={
                                      leadType === true
                                        ? "Lead.AddNewResidential"
                                        : "Lead.AddNewCommercial"
                                    }
                                  />
                                </Button>
                              </div>
                            </>
                          )}
                          value={selectedClientId || undefined}
                        >
                          {selectedClientId &&
                            clients
                              ?.filter(
                                (client) => client.id === selectedClientId
                              )
                              .map((client) => (
                                <Select.Option
                                  key={client.id}
                                  value={client.id}
                                  label={client.nameEn}
                                >
                                  {client.nameEn} | {client.phone}
                                </Select.Option>
                              ))}
                          {searchValue &&
                            clients
                              ?.filter(
                                (client) =>
                                  client.isResidential &&
                                  (client.nameEn
                                    ?.toLowerCase()
                                    .includes(searchValue.toLowerCase()) ||
                                    client.phone?.includes(searchValue)) &&
                                  client.id !== selectedClientId
                              )
                              .map((client) => (
                                <Select.Option
                                  key={client.id}
                                  value={client.id}
                                  label={client.nameEn}
                                >
                                  {client.nameEn} | {client.phone}
                                </Select.Option>
                              ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {leadType === false && (
                    <Col xs={24} sm={24} lg={12}>
                      <Form.Item
                        label={<FormattedMessage id="Lead.CompanyName" />}
                        name="clientId"
                        rules={[
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: "Lead.Error.CompanyName",
                            }),
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          allowClear
                          popupClassName="custom-company-select"
                          optionLabelProp="label"
                          placeholder={intl.formatMessage({
                            id: "Lead.PlaceHolder.SelectCompanyName",
                          })}
                          style={{ width: "100%" }}
                          onChange={handleChange}
                          onSearch={(value) => {
                            setSearchValue(value);
                            if (value) {
                              dispatch(getClientAPI(value));
                            } else {
                              dispatch(getClientAPI());
                            }
                          }}
                          filterOption={false}
                          notFoundContent={<div />}
                          value={selectedClientId || undefined}
                          dropdownRender={(menu) => (
                            <>
                              {menu}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  type="link"
                                  icon={<PlusOutlined />}
                                  style={{
                                    padding: 0,
                                    color: "#1677ff",
                                    fontWeight: 600,
                                    marginLeft: 8,
                                  }}
                                  onClick={showDrawer2}
                                >
                                  <FormattedMessage id="Lead.AddNewCommercial" />
                                </Button>
                              </div>
                            </>
                          )}
                        >
                          {selectedClientId &&
                            clients
                              ?.filter(
                                (client) => client.id === selectedClientId
                              )
                              .map((client) => (
                                <Select.Option
                                  key={client.id}
                                  value={client.id}
                                  label={client.companyName}
                                >
                                  {client.companyName} | {client.phone}
                                </Select.Option>
                              ))}
                          {searchValue &&
                            clients
                              ?.filter(
                                (client) =>
                                  client.isCommercial &&
                                  (client.companyName
                                    ?.toLowerCase()
                                    .includes(searchValue.toLowerCase()) ||
                                    client.phone?.includes(searchValue)) &&
                                  client.id !== selectedClientId
                              )
                              .map((client) => (
                                <Select.Option
                                  key={client.id}
                                  value={client.id}
                                  label={client.companyName}
                                >
                                  {client.companyName} | {client.phone}
                                </Select.Option>
                              ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                <Row gutter={16}>
                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label={<FormattedMessage id="Quote.Services" />}
                      name="companyServiceId"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "Lead.Error.ServiceType",
                          }),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        placeholder={intl.formatMessage({
                          id: "Quote.Placeholder.SelectService",
                        })}
                        style={{ width: "100%" }}
                      >
                        {companyServices
                          ?.filter((company) => company?.companyId == companyId)
                          ?.map((company) => (
                            <Select.Option
                              key={company?.id}
                              value={company?.id}
                            >
                              {
                                company[
                                  `name${
                                    selectedLanguage === "fr-FR" ? "Fr" : "En"
                                  }`
                                ]
                              }
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label={<FormattedMessage id="Leads.SalesPerson" />}
                      name="responsibleId"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "Lead.PlaceHolder.PleaseSelectResponsiblePerson",
                          }),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder={intl.formatMessage({
                          id: "Lead.PlaceHolder.SelectResponsiblePerson",
                        })}
                        optionFilterProp="children"
                      >
                        {employeeList
                          ?.filter(
                            (employee) => employee?.roleId === RoleEnum.Sales.id
                          )
                          .map((employee) => (
                            <Select.Option
                              key={employee?.id}
                              value={employee?.id}
                            >
                              {employee?.firstName} {employee?.lastName}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label={<FormattedMessage id="Lead.SourceOfLead" />}
                      name="sourceOfLeadId"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "Lead.PlaceHolder.PleaseSelectSourceOfLead",
                          }),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        placeholder={intl.formatMessage({
                          id: "Lead.PlaceHolder.SelectSourceOfLead",
                        })}
                        style={{ width: "100%" }}
                        onChange={(value) => {
                          setSelectedSourceOfLeadId(value);
                          form.setFieldValue("sourceOfLeadId", value);
                        }}
                      >
                        {sourceOfLeads?.map((source) => (
                          <Select.Option key={source?.id} value={source?.id}>
                            {source?.sourceName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {selectedSourceOfLeadId === 4 && (
                    <Col xs={24} sm={12} lg={8}>
                      <Form.Item
                        label={<FormattedMessage id="Leads.ReferredBy" />}
                        name="referredBy"
                      >
                        <Input
                          placeholder={intl.formatMessage({
                            id: "Leads.Placeholder.EnterReferredName",
                          })}
                          maxLength={50}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  <Col xs={24} sm={12} lg={5}>
                    <Form.Item
                      label={<FormattedMessage id="Lead.Commission" />}
                    >
                      <Input.Group compact>
                        <Form.Item
                          name="commisionPercentage"
                          noStyle
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const type = getFieldValue("commisionAmount");
                                if (type === 1 && value > 100) {
                                  return Promise.reject(
                                    new Error(
                                      intl.formatMessage({
                                        id: "Lead.Rule.CommissionMaxPercent",
                                      })
                                    )
                                  );
                                }
                                if (
                                  type === 2 &&
                                  value?.toString().length > 15
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      intl.formatMessage({
                                        id: "Lead.Rule.CommissionMaxDollar",
                                      })
                                    )
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input
                            min={0}
                            type="number"
                            style={{ width: "50%" }}
                            // placeholder={intl.formatMessage({
                            //   id: "Lead.PlaceHolder.EnterCommission",
                            // })}
                          />
                        </Form.Item>
                        <Form.Item
                          name="commisionAmount"
                          noStyle
                          initialValue={1}
                        >
                          <Select style={{ width: "50%" }}>
                            <Select.Option value={1}>%</Select.Option>
                            <Select.Option value={2}>$</Select.Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} sm={22}>
                    <Form.Item
                      label={<FormattedMessage id="Lead.Requirement" />}
                      name="requirement"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "Lead.Error.Requirement",
                          }),
                        },
                      ]}
                    >
                      <Input.TextArea
                        placeholder={intl.formatMessage({
                          id: "Lead.PlaceHolder.Requirement",
                        })}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="center" className="mt-10">
                  <Space>
                    <Button danger size="medium" onClick={handleCancel}>
                      <CloseCircleOutlined />
                      {<FormattedMessage id="Lead.Cancel" />}
                    </Button>
                    <Button type="primary" size="medium" htmlType="submit">
                      <CheckCircleOutlined />
                      <FormattedMessage
                        id={id ? "Common.Save" : "Lead.Submit"}
                      />
                    </Button>
                  </Space>
                </Row>
              </Col>
              <Col span={24} md={12} lg={10}>
                {selectedClientId && clientById && clientById?.id && (
                  <Row gutter={16}>
                    <Col xs={24} sm={24} className="text-right">
                      <Button
                        color="primary"
                        type="link"
                        className="position-edit"
                        onClick={() => {
                          setEditClientId(clientById?.id);
                          setEditClientModalOpen(true);
                        }}
                      >
                        <EditOutlined />
                        {<FormattedMessage id="Common.Edit" />}
                      </Button>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label={<FormattedMessage id="Lead.MainContactInfo" />}
                      >
                        <p>
                          <FontAwesomeIcon icon={faUser} className="f-11" />
                          <span>
                            {" "}
                            {leadType ? mainContact.name : clientById?.name}
                          </span>
                        </p>
                        <p className="mt-5px">
                          <FontAwesomeIcon
                            icon={faPhoneSquare}
                            className="f-11"
                          />
                          <span>
                            {" "}
                            {mainContact.countryCode} {mainContact.phone}
                          </span>
                        </p>
                        <p className="mt-5px">
                          <FontAwesomeIcon icon={faEnvelope} className="f-11" />
                          <span> {mainContact.email}</span>
                        </p>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label={
                          leadType ? (
                            <FormattedMessage id="Lead.AlternateContactInfo" />
                          ) : (
                            <FormattedMessage
                              id="Lead.AccountingContactInfo"
                              defaultMessage="Accounting Contact Info"
                            />
                          )
                        }
                      >
                        <p>
                          <FontAwesomeIcon icon={faUser} className="f-11" />
                          <span> {altContact.name}</span>
                        </p>
                        <p className="mt-5px">
                          <FontAwesomeIcon
                            icon={faPhoneSquare}
                            className="f-11"
                          />
                          <span>
                            {" "}
                            {altContact.countryCode} {altContact.phone}
                          </span>
                        </p>
                        <p className="mt-5px">
                          <FontAwesomeIcon icon={faEnvelope} className="f-11" />
                          <span> {altContact.email}</span>
                        </p>
                      </Form.Item>
                    </Col>
                    <Divider />
                    <Col xs={24} sm={12}>
                      <Form.Item label="Delivery Address">
                        <EditFilled
                          className="edit-icon-quote"
                          onClick={() =>
                            openAddressModal(AddressType.CompanyAddress.name)
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <p style={{ paddingRight: 20 }}>
                          {renderAddress(deliveryAddress)}
                        </p>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item label="Billing Address">
                        <EditFilled
                          className="edit-icon-quote"
                          onClick={() =>
                            openAddressModal(AddressType.BillingAddress.name)
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <p style={{ paddingRight: 20 }}>
                          {renderAddress(billingAddress)}
                        </p>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Form>
          <Drawer
            title={editClientId ? "Edit Client" : "Add Client"}
            width={600}
            onClose={() => setEditClientModalOpen(false)}
            open={editClientModalOpen}
            destroyOnClose
            style={{ top: 20 }}
            footer={null}
          >
            <AddClient
              clientId={editClientId}
              onSuccess={(id) => {
                setEditClientModalOpen(false);
                if (id) {
                  setEditClientId(id);
                  setNewClientId(id);
                  setSelectedClientId(id);
                  dispatch(GetClientByIdApi(id));
                }
              }}
              isValidationRequired={false}
              onClose={() => setEditClientModalOpen(false)}
              leadType={leadType ? "Residential" : "Commercial"}
            />
          </Drawer>
        </div>
      </div>

      {/* <Modal
        title={
          props?.selectedLead ? (
            <FormattedMessage id="Lead.EditLead" />
          ) : (
            <FormattedMessage id="Lead.AddLead" />
          )
        }
        width={800}
        onCancel={props?.onClose}
        open={props?.open}
        footer={null}
      >
     
      </Modal> */}
      {isAddressModalOpen && (
        <QuoteAddress
          billingAddress={billingAddress}
          shippingAddress={deliveryAddress}
          setBillingAddress={setBillingAddress}
          setShippingAddress={setDeliveryAddress}
          onCancel={() => setIsAddressModalOpen(false)}
          addressType={addressType}
          hideEdit={true}
        />
      )}
    </>
  );
}

export default AddLead;
